import type { SwadeItemContainerInterface } from "@/types/items";

export interface ItemTypeRules {
    defaultStatus: string;
    inUseStatuses: readonly string[];
    multiplier?: (container: SwadeItemContainerInterface) => number;
    statusIcons?: Record<string, string>;
    statusLabelFallback?: Record<string, string>;
}

export const ITEM_TYPE_RULES: Record<string, ItemTypeRules> = {
    cyberware: {
        defaultStatus: 'uninstalled',
        inUseStatuses: ['installed'],
        multiplier: (c) => c.quantity ?? 1,
        statusIcons: { installed: 'fa-plug-circle-bolt', uninstalled: 'fa-plug', stored: 'fa-box-archive' },
        statusLabelFallback: { installed: 'Installed', uninstalled: 'Uninstalled', stored: 'Stored' },
    },
    armor: {
        defaultStatus: 'equipped',
        inUseStatuses: ['equipped'],
        statusIcons: { equipped: 'fa-helmet-battle' },
    },
    shield: {
        defaultStatus: 'equipped',
        inUseStatuses: ['equipped'],
        statusIcons: { equipped: 'fa-shield-halved' },
    },
    weapon: {
        defaultStatus: 'primary',
        inUseStatuses: ['primary', 'secondary', 'two-handed'],
    },
};

export const DEFAULT_ITEM_RULES: ItemTypeRules = {
    defaultStatus: 'carried',
    inUseStatuses: ['carried'],
};

export const rulesFor = (type: string | null | undefined): ItemTypeRules =>
    (type && ITEM_TYPE_RULES[type]) ? ITEM_TYPE_RULES[type] : DEFAULT_ITEM_RULES;
